/* eslint-disable @typescript-eslint/no-explicit-any */
import { fetch } from 'http-common';

import { CatalogueData } from 'types/api/catalogue.type';
import { NotificationPDF } from 'types/api/notification.type';
import { SelectionItem } from 'types/api/selection.type';

type SelectionPDFData = {
  name: string;
  products: SelectionItem[];
  isEnglish?: boolean;
};

type CataloguePDFData = {
  season: string;
  seasonLine: string;
  data: CatalogueData[];
};

class PDFService {
  private http = fetch(process.env.REACT_APP_LAMBDA_PDF, {
    responseType: 'arraybuffer',
    'Content-Type': 'application/json',
    Accept: 'application/pdf',
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async getOrderPDF(order: any) {
    return this.http.post<{ downloadUrl: string }>('/generatePDF', order);
  }

  public async getNotificationPDF(notification: NotificationPDF) {
    return this.http.post('/getNotificationPDF/', notification, {
      responseType: 'blob',
    });
  }

  public async getSelectionPDF(data: SelectionPDFData) {
    return this.http.post('/getSelectionPDF/', data, {
      responseType: 'blob',
    });
  }

  public async getCataloguePDF(data: CataloguePDFData) {
    return this.http.post('/getCataloguePDF/', data);
  }

  public async getSingleProductPDF(data: any) {
    return this.http.post('/singleProductPDF/', data, {
      responseType: 'blob',
    });
  }
}

const pdfService = new PDFService();

export { pdfService };
